const centerMapOnMarkers = (markers, location, google, map) => {
    const bounds = new google.maps.LatLngBounds()

    if (markers.length > 0) {
        markers.forEach(marker => {
            const { latitude, longitude } = marker

            if (latitude !== null && longitude !== null) {
                bounds.extend(new google.maps.LatLng(latitude, longitude))
            }
        })

        // extend bounds to avoid too much zoom
        const offset = !location ? 1 : 0.1
        const boundsCenter = bounds.getCenter()
        bounds.extend(new google.maps.LatLng(boundsCenter.lat() + offset, boundsCenter.lng() + offset))
        bounds.extend(new google.maps.LatLng(boundsCenter.lat() - offset, boundsCenter.lng() - offset))
        // Fit bounds
        map.fitBounds(bounds)
    }
}

export default centerMapOnMarkers